import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { THEME } from 'src/enums/theme';
import amzLogoBlack from 'src/images/Amazon_Logo_Black.png';
import amzLogoWhite from 'src/images/Amazon_Logo_White.png';

import styles from './Logo.module.scss';

type StyleVariant = 'primary' | 'secondary';

interface LogoProps {
  altText: string;
  href: string;
  styleVariant?: StyleVariant;
  theme?: THEME;
}

export const Logo: FunctionComponent<LogoProps> = ({
  altText,
  href,
  styleVariant = 'primary',
  theme = THEME.LIGHT,
}) => {
  let srcImage;
  if (theme === THEME.DARK || theme === THEME.REBRAND_DARK) {
    srcImage = amzLogoWhite;
  } else if (styleVariant === 'primary' || theme === THEME.REBRAND_LIGHT) {
    srcImage = amzLogoBlack;
  } else {
    srcImage = amzLogoWhite;
  }

  return (
    <a className={styles.link} href={href}>
      <img alt={altText} className={classNames(styles.logo, styles.amzLogo)} src={srcImage} />
    </a>
  );
};
